import { render, staticRenderFns } from "./AllPaperTest.vue?vue&type=template&id=0be8cdf2&style=height%3A%20100%25%3B"
import script from "./AllPaperTest.vue?vue&type=script&lang=js"
export * from "./AllPaperTest.vue?vue&type=script&lang=js"
import style0 from "./AllPaperTest.vue?vue&type=style&index=0&id=0be8cdf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports